import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import axios from "axios";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";

import defaultAvatar from "assets/img/placeholder.jpg";
import AxiosMaster from '../../AxiosFactory';

class ImageUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            upload: "none",
            uploading: false,
            hitSubmit: false,
            hitimage: false,
            imagePreviewUrl: defaultAvatar,
            removeoff: true,
            uploadprogress: 0,
            imageurl: ""
        };
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleImageSubmit = this.handleImageSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        };
        reader.readAsDataURL(file);
    }

    handleImageSubmit(callback) {
        const BASE_URL = AxiosMaster.base + '/upload/' + this.props.role + 'Images';
        this.setState({hitSubmit: true});
        this.setState({uploading: true});
        var data = new FormData();
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }, onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                this.setState({uploadprogress: percentCompleted});
            }.bind(this)
        }
        data.append("file", this.state.file);
        axios.post(BASE_URL, data, config) //pass config as third parameter for onUploadProgress
            .then(json => {
                this.setState({imageurl: json.data.path});
                callback(json.data.path);
                this.setState({upload: "success"});
                this.setState({uploading: false});
            }).catch(err => {
            this.setState({upload: "error"});
            this.setState({uploading: false});
        });
    }

    componentDidUpdate() {
        if (this.state.file !== null && this.state.hitSubmit === false) {
            this.handleImageSubmit(function (url) {
                this.props.handleImageUrl(url);
            }.bind(this));
        }
    }


    handleClick() {
        this.refs.fileInput.click();
        this.setState({upload: "none"});
        this.setState({hitSubmit: false});
        this.setState({removeoff: true});
    }

    handleRemove() {
        this.setState({
            file: null,
            imagePreviewUrl: defaultAvatar
        });
        this.refs.fileInput.value = null;
        this.setState({upload: "none"});
        this.setState({hitSubmit: false});
        this.setState({removeoff: false});
        var url = "";
        this.props.handleImageUrl(url);
    }

    render() {
        var {
            avatar,
            addButtonProps,
            changeButtonProps,
            removeButtonProps
        } = this.props;

        return (
            <div className="fileinput text-center">
                <input type="file" onChange={this.handleImageChange} ref="fileInput"/>
                <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
                    <img src={this.state.imagePreviewUrl} onError={(e) => {
                        e.onerror = null;
                        e.target.src = require('assets/img/placeholder.jpg')
                    }}/>
                </div>
                <div>
                    {this.state.file === null ? (
                        <Button {...addButtonProps} onClick={() => this.handleClick()}>
                            {avatar ? "Add Photo" : "Select image"}
                        </Button>
                    ) : (
                        <span>
              <Button {...changeButtonProps} onClick={() => this.handleClick()}>
                Change
              </Button>
                            {avatar ? <br /> : null}
                            <Button
                                {...removeButtonProps}
                                onClick={() => this.handleRemove()}
                            >
                <i className="fas fa-times"/> Remove
              </Button>
            </span>)}</div>
                {
                    this.state.removeoff ? ( <div>
                        <div>
                            {this.state.uploading ? (<div><p>Uploading ... </p><CustomLinearProgress
                                variant="determinate"
                                color="info"
                                value={this.state.uploadprogress}
                            /></div>) : null}
                        </div>
                        <div>
                            {this.state.upload === "success" ? (<p>Uploaded</p>) : null}
                        </div>
                        <div>
                            {this.state.upload === "error" ? (<p style={{
                                color: 'red',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }}>Upload Error</p>) : null}
                        </div>
                    </div>) : null
                }
            </div>
        );
    }
}

ImageUpload.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx